import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Store } from "../types/modules/store.type";

export interface StoreState {
  accessToken: string;
  refreshToken: string;
  store: Store;
}

const initialState: StoreState = {
  accessToken: "",
  refreshToken: "",
  store: {} as Store,
};

const storeSlice = createSlice({
  name: "store",
  initialState,
  reducers: {
    loginStore(
      state,
      action: PayloadAction<{
        accessToken: string;
        refreshToken: string;
        store: Store;
      }>
    ) {
      state.refreshToken = action.payload.refreshToken;
      state.accessToken = action.payload.accessToken;
      state.store = action.payload.store;
    },
    logoutStore(state) {
      state.refreshToken = "";
      state.accessToken = "";
      state.store = {} as Store;
    },
    refreshStoreTokens(
      state,
      action: PayloadAction<{ accessToken: string; refreshToken: string }>
    ) {
      state.refreshToken = action.payload.refreshToken;
      state.accessToken = action.payload.accessToken;
    },
  },
});

export const { loginStore, logoutStore, refreshStoreTokens } =
  storeSlice.actions;
export default storeSlice.reducer;
